<script lang="ts">
  import ArticlesSidebar from '$lib/components/sidebars/ArticlesSidebar.svelte';
  import MarkdownContent from '$lib/components/MarkdownContent.svelte';
  import type { PageData } from './$types.js';
  import Section from '$lib/components/Section.svelte';

  export let data: PageData;

  export const isSameDay = (d1: Date, d2: Date): boolean =>
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();
</script>

<svelte:head>
  {#if data.article.description}
    <meta name="description" content={data.article.description} />
  {/if}
</svelte:head>

<div class="fixed-width grid two-columns">
  <main>
    <Section headline={data.article.title}>
      <div>
        Gepubliceerd op <time datetime={data.article.published.toISOString()}
          >{data.article.published.toLocaleDateString('nl-NL', {
            day: 'numeric',
            month: 'long',
            weekday: undefined,
            year: 'numeric'
          })}</time
        >.
        {#if data.article.edited && !isSameDay(data.article.published, data.article.edited)}
          Gewijzigd op <time datetime={data.article.edited.toISOString()}
            >{data.article.edited.toLocaleDateString('nl-NL', {
              day: 'numeric',
              month: 'long',
              weekday: undefined,
              year: 'numeric'
            })}</time
          >.
        {/if}
        {#if data.article.author}
          Geschreven door <a href={data.article.author.permalink}>{data.article.author.name}</a>.
        {/if}
      </div>
      <MarkdownContent content={data.article.content} />
    </Section>
  </main>
  <aside>
    <!-- Article image -->
    {#if data.article.image}
      {@const { image } = data.article}
      <img
        class="article-image"
        src={image.url}
        width={image.width?.toString(10)}
        height={image.height?.toString(10)}
        alt={image.description}
        loading="lazy" />
    {/if}
    <!-- Related articles -->
    <ArticlesSidebar articles={data.sidebarArticles} categoryId={data.article.categoryId} />
  </aside>
</div>

<style lang="scss">
  @use '$lib/styles/templates/twoColumnsPage';
  @use '$lib/styles/variables';

  img.article-image {
    height: auto;
    width: 100%;
    object-fit: contain;

    @include variables.section-box-shadow;

    border-radius: variables.$section-border-radius;
    display: block;
  }
</style>
